exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, \"Apple LiGothic\", 微軟正黑體, \"Microsoft JhengHei\", sans-serif; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./~/postcss-loader!./src/static/styles/baseStyle.scss
// module id = 351
// module chunks = 0